"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Loader_1 = __importDefault(require("../../Loader"));
const styled_1 = require("./styled");
const MOONPAY_SCRIPTS = {
    production: {
        script: "https://buy.moonpay.com",
        key: "pk_live_k6WSd0AaHVEXPV4WlBBrsvRMrAhRH",
    },
    development: {
        script: "https://buy-staging.moonpay.com",
        key: "pk_test_1BktOhJqGEW5LuoslX9z1Kupc76LfWrz",
    },
};
const MoonpayWidget = (_a) => {
    var { crypto, email, wallet, baseCurrencyAmount, baseCurrencyCode, defaultCurrencyCode, language, externalTransactionId, env } = _a, rest = __rest(_a, ["crypto", "email", "wallet", "baseCurrencyAmount", "baseCurrencyCode", "defaultCurrencyCode", "language", "externalTransactionId", "env"]);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [frameSrc, setFrameSrc] = (0, react_1.useState)("");
    (0, react_1.useEffect)(() => {
        const colorCode = "#0AC18E";
        const moonPayAPIKey = `apiKey=${MOONPAY_SCRIPTS[env].key}`;
        const color = `&colorCode=${encodeURIComponent(colorCode)}`;
        const enableRecurringBuys = `&enableRecurringBuys=true`;
        const queries = [moonPayAPIKey, color, enableRecurringBuys];
        if (baseCurrencyAmount && baseCurrencyAmount >= 20)
            queries.push(`&baseCurrencyAmount=${baseCurrencyAmount}`);
        if (baseCurrencyCode)
            queries.push(`&baseCurrencyCode=${baseCurrencyCode}`);
        if (defaultCurrencyCode) {
            queries.push(`&defaultCurrencyCode=${defaultCurrencyCode}`);
        }
        else {
            queries.push(`&defaultCurrencyCode=BCH`);
        }
        if (language)
            queries.push(`&language=${language}`);
        if (email && wallet) {
            queries.push(`&currencyCode=bch`);
            queries.push(`&walletAddres=${wallet}`);
            queries.push(`&email=${email}`);
            queries.push(`&redirectURL=${window.location.href}`);
        }
        else if (crypto) {
            queries.push(`&currencyCode=${crypto}`);
            queries.push(`&defaultCurrencyCode=${crypto}`);
        }
        if (externalTransactionId)
            queries.push(`&externalTransactionId=${externalTransactionId}`);
        const url = `${MOONPAY_SCRIPTS[env].script}?${queries.join("")}`;
        setFrameSrc(url);
    }, [
        baseCurrencyAmount,
        baseCurrencyCode,
        crypto,
        defaultCurrencyCode,
        email,
        env,
        externalTransactionId,
        language,
        wallet,
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        loading && (react_1.default.createElement(styled_1.LoaderContainer, null,
            react_1.default.createElement(Loader_1.default, null))),
        frameSrc && (react_1.default.createElement("iframe", Object.assign({ title: "MoonPay widget", allow: "accelerometer; autoplay; camera; gyroscope; payment", frameBorder: "0", onLoad: () => {
                setLoading(false);
            }, src: frameSrc }, rest),
            react_1.default.createElement("p", null, "Your browser does not support iframes.")))));
};
exports.default = MoonpayWidget;
//# sourceMappingURL=MoonpayWidget.js.map